module.exports = __webpack_public_path__ + "media/images/games/k2gender/doll-7d571e6da9878e08029ade57590996d4.png";